const ACTION_PHRASES = {
  delay: 'delays',
  move: 'moves',
  change: 'changes',
  melee: 'attacks',
  ranged: 'shoots',
  reload: 'reloads',
  aim: 'aims',
  healing: 'heals',
  magic: 'prepares/casts magic as action',
  'remove counter': 'removes counter',
  'special action': 'performs special action',
  'no action': 'takes no action',
}

const ACTION_UNDO_PHRASES = {
  delay: 'undoes delay',
  move: 'undoes move',
  change: 'undoes change',
  melee: 'undoes attack',
  ranged: 'undoes shot',
  reload: 'undoes reload',
  aim: 'undoes aim',
  healing: 'undoes healing',
  magic: 'undoes action magic',
  'remove counter': 'undoes counter removal',
  'special action': 'undoes special action',
  'no action': 'undoes no action',
}

const REACTION_PHRASES = {
  parry: 'parries',
  dodge: 'dodges',
  magic: 'prepares/casts magic as reaction',
  'special reaction': 'performs special reaction',
}

const REACTION_UNDO_PHRASES = {
  parry: 'undoes parry',
  dodge: 'undoes dodge',
  magic: 'undoes reaction magic',
  'special reaction': 'undoes special reaction',
}

const MARKER_PHRASES = {
  counter: 'has counter(s)',
  'buff magic': 'buffed through magic',
  'nerf magic': 'nerfed through magic',
  poisoned: 'poisoned',
  psyched: 'psyched',
  constrained: 'constrained',
  'special marker': 'special marker',
}

const MARKER_UNDO_PHRASES = {
  counter: 'removes counter(s)',
  'buff magic': 'is no longer buffed through magic',
  'nerf magic': 'is no longer nerfed through magic',
  poisoned: 'is no longer poisoned',
  psyched: 'is no longer psyched',
  constrained: 'is no longer constrained',
  'special marker': 'removes special marker',
}

function normaliseKey(value) {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
}

function resolvePhrase({ category, name, undo = false }) {
  const key = normaliseKey(name)

  if (category === 'action') {
    return undo ? (ACTION_UNDO_PHRASES[key] ?? `undoes ${key}`) : (ACTION_PHRASES[key] ?? key)
  }

  if (category === 'reaction') {
    return undo ? (REACTION_UNDO_PHRASES[key] ?? `undoes ${key}`) : (REACTION_PHRASES[key] ?? key)
  }

  if (category === 'marker') {
    return undo ? (MARKER_UNDO_PHRASES[key] ?? `undoes ${key}`) : (MARKER_PHRASES[key] ?? key)
  }

  return ''
}

function getCombatPrefix({ round, actionNumber, extraAttacks = false } = {}) {
  if (extraAttacks) {
    return `Round ${round ?? 0} Extra Attacks`
  }

  return `Round ${round ?? 0} Action ${actionNumber ?? 0}`
}

export default function buildCombatLogDescription({
  round,
  actionNumber,
  combatantName,
  category,
  name,
  undo = false,
  extraAttacks = false,
} = {}) {
  const phrase = resolvePhrase({ category, name, undo })

  if (!combatantName || !phrase) {
    return ''
  }

  return `${getCombatPrefix({ round, actionNumber, extraAttacks })} - ${combatantName} ${phrase}`
}
